"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f1605 = void 0;
exports.f1605 = {
    "مليسيا": [
        5068
    ],
    "مازرونی": [
        5269
    ],
    "ملايو": [
        9078
    ]
};
